import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { inventarioService } from '../../services/api';
import { btnSecundario, chip } from '../../components/ui/estilos';
import { Encabezado, Tabla, Tarjeta } from './ui';
import { cant, estadoInsumo } from '../almacen/insumos';

// Insumos en o bajo su mínimo (sobre lo disponible). No depende de un periodo: es el estado de ahora.
export default function Alertas() {
  const [alertas, setAlertas] = useState<any[] | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => { inventarioService.getAlertas().then(r => setAlertas(r.data)).catch(() => setError(true)); }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
      <Encabezado titulo="Alertas de inventario"
        extra={<Link to="/inventario" style={{ ...btnSecundario, height: 38, fontSize: 14, padding: '0 12px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none' }}>Ir a Inventario</Link>} />
      {error && <div role="alert" style={{ color: 'var(--danger)', fontWeight: 700 }}>No se pudieron revisar las existencias.</div>}
      {!alertas && !error && <div style={{ color: 'var(--muted)' }}>Cargando…</div>}
      {alertas && (
        <Tarjeta titulo={alertas.length ? `${alertas.length} insumo${alertas.length > 1 ? 's' : ''} por surtir` : 'Todo en orden'}>
          <Tabla vacio="Todo el inventario está sobre su mínimo."
            columnas={[{ t: 'INSUMO', w: 'minmax(0,1fr)' }, { t: 'DISPONIBLE', w: '120px', der: true }, { t: 'MÍNIMO', w: '90px', der: true }, { t: 'ESTADO', w: '120px' }]}
            filas={alertas.map(x => {
              const e = estadoInsumo(x);
              return [<b>{x.nombre}</b>, `${cant(x.stock_disponible)} ${x.unidad}`, cant(x.stock_minimo), <span style={{ ...chip(e.bg, e.fg), fontSize: 13 }}>{e.label}</span>];
            })} />
        </Tarjeta>
      )}
    </div>
  );
}
